<template>
  <section id="comments">
    <div class="demo">
      <div class="row">
        <div class="col-md-5 col-xl-4 mb-5">
          <article class="commentary">
            <ol class="comment" aria-label="comments">
              <li class="comment-item">
                <div class="comment-head">
                  <span class="avatar" aria-hidden="true">
                    <img
                      alt="Peter Parker"
                      class="img-fluid"
                      src="@/assets/gel/site-images/avatar.svg"
                    >
                  </span>
                  <span class="comment-info">
                    <h5>Peter Parker</h5>
                    <time aria-label="time">4 hours ago</time>
                  </span>
                </div>
                <div
                  class="comment-body"
                >Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident</div>
              </li>
              <li class="comment-item">
                <div class="comment-head">
                  <span class="avatar" aria-hidden="true">DW</span>
                  <span class="comment-info">
                    <h5>Daniel Wang</h5>
                    <time aria-label="time">2 hours ago</time>
                  </span>
                  <span class="comment-action">
                    <div class="dropdown d-inline-block">
                      <button
                        type="button"
                        title="Actions"
                        aria-label="actions"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                        class="btn btn-icon btn-sm dropdown-toggle no-caret mr-0"
                      >
                        <i
                          aria-hidden="true"
                          class="gel-icon-ellipsis"
                          data-toggle="tooltip"
                          data-placement="top"
                          data-original-title="Actions"
                        ></i>
                      </button>
                      <div class="dropdown-menu dropdown-menu-right">
                        <a href="#" class="dropdown-item">Edit</a>
                        <a href="#" class="text-danger dropdown-item">Delete</a>
                      </div>
                    </div>
                  </span>
                </div>
                <div
                  class="comment-body"
                >Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</div>
              </li>
            </ol>
            <div class="commentbox" aria-label="comment box">
              <span class="avatar" aria-hidden="true">DW</span>
              <div class="commentbox-input">
                <label for="comment-input" class="sr-only">Make a comment</label>
                <input id="comment-input" type="text" class="form-control" placeholder="reply">
              </div>
            </div>
          </article>
        </div>
        <div class="col-md-7 offset-lg-1 col-lg-6 offset-xl-2">
            <article class="commentary">
              <ol
                class="comment scroll"
                aria-label="comments"
                style="max-height: 500px;height: 500px;overflow-y: auto;"
              >
                <li class="comment-item">
                  <div class="comment-head">
                    <span class="avatar" aria-hidden="true">
                      <img
                        alt="Peter Parker"
                        class="img-fluid"
                        src="@/assets/gel/site-images/avatar.svg"
                      >
                    </span>
                    <span class="comment-info">
                      <h5>Peter Parker</h5>
                      <time aria-label="time">1 day ago</time>
                    </span>
                    <span class="comment-action">
                      <div class="dropdown d-inline-block">
                        <button
                          type="button"
                          title="Actions"
                          aria-label="actions"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          class="btn btn-icon btn-sm dropdown-toggle no-caret mr-0"
                        >
                          <i
                            aria-hidden="true"
                            class="gel-icon-ellipsis"
                            data-toggle="tooltip"
                            data-placement="top"
                            data-original-title="Actions"
                          ></i>
                        </button>
                        <div class="dropdown-menu dropdown-menu-right">
                          <a href="#" class="dropdown-item">Edit</a>
                          <a href="#" class="text-danger dropdown-item">Delete</a>
                        </div>
                      </div>
                    </span>
                  </div>
                  <div
                    class="comment-body"
                  >Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident</div>
                </li>
                <li class="comment-item">
                  <div class="comment-head">
                    <span class="avatar" aria-hidden="true">DW</span>
                    <span class="comment-info">
                      <h5>Daniel Wang</h5>
                      <time aria-label="time">3 hours ago</time>
                    </span>
                  </div>
                  <div
                    class="comment-body"
                  >Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</div>
                </li>
                <li class="comment-item">
                  <div class="comment-head">
                    <span class="avatar" aria-hidden="true">
                      <img
                        alt="Peter Parker"
                        class="img-fluid"
                        src="@/assets/gel/site-images/avatar.svg"
                      >
                    </span>
                    <span class="comment-info">
                      <h5>Peter Parker</h5>
                      <time aria-label="time">3 hours ago</time>
                    </span>
                    <span class="comment-action">
                      <div class="dropdown d-inline-block">
                        <button
                          type="button"
                          title="Actions"
                          aria-label="actions"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          class="btn btn-icon btn-sm dropdown-toggle no-caret mr-0"
                        >
                          <i
                            aria-hidden="true"
                            class="gel-icon-ellipsis"
                            data-toggle="tooltip"
                            data-placement="top"
                            data-original-title="Actions"
                          ></i>
                        </button>
                        <div class="dropdown-menu dropdown-menu-right">
                          <a href="#" class="dropdown-item">Edit</a>
                          <a href="#" class="text-danger dropdown-item">Delete</a>
                        </div>
                      </div>
                    </span>
                  </div>
                  <div
                    class="comment-body"
                  >Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident</div>
                </li>
                <li class="comment-item">
                  <div class="comment-head">
                    <span class="avatar" aria-hidden="true">DW</span>
                    <span class="comment-info">
                      <h5>Daniel Wang</h5>
                      <time aria-label="time">2 hours ago</time>
                    </span>
                  </div>
                  <div
                    class="comment-body"
                  >Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</div>
                </li>
                <li class="comment-item">
                  <div class="comment-head">
                    <span class="avatar" aria-hidden="true">
                      <img
                        alt="Peter Parker"
                        class="img-fluid"
                        src="@/assets/gel/site-images/avatar.svg"
                      >
                    </span>
                    <span class="comment-info">
                      <h5>Peter Parker</h5>
                      <time aria-label="time">1 hours ago</time>
                    </span>
                    <span class="comment-action">
                      <div class="dropdown d-inline-block">
                        <button
                          type="button"
                          title="Actions"
                          aria-label="actions"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          class="btn btn-icon btn-sm dropdown-toggle no-caret mr-0"
                        >
                          <i
                            aria-hidden="true"
                            class="gel-icon-ellipsis"
                            data-toggle="tooltip"
                            data-placement="top"
                            data-original-title="Actions"
                          ></i>
                        </button>
                        <div class="dropdown-menu dropdown-menu-right">
                          <a href="#" class="dropdown-item">Edit</a>
                          <a href="#" class="text-danger dropdown-item">Delete</a>
                        </div>
                      </div>
                    </span>
                  </div>
                  <div
                    class="comment-body"
                  >Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident</div>
                </li>
                <li class="comment-item">
                  <div class="comment-head">
                    <span class="avatar" aria-hidden="true">DW</span>
                    <span class="comment-info">
                      <h5>Daniel Wang</h5>
                      <time aria-label="time">19 mins ago</time>
                    </span>
                  </div>
                  <div
                    class="comment-body"
                  >Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</div>
                </li>
              </ol>
              <div class="commentbox expanded" aria-label="comment box">
                <span class="avatar" aria-hidden="true">
                  <img alt="Peter Parker" class="img-fluid" src="@/assets/gel/site-images/avatar.svg">
                </span>
                <div class="commentbox-input">
                  <label for="comment-input-expanded" class="sr-only">Make a comment</label>
                  <textarea id="comment-input-expanded" class="form-control"></textarea>
                  <div class="text-right mt-2">
                    <button type="button" class="btn btn-link btn-sm">Cancel</button>
                    <button type="button" class="btn btn-primary btn-sm">Send</button>
                  </div>
                </div>
              </div>
            </article>
        </div>
      </div>
    </div>
    <section class="md" v-html="mdfile"></section>
  </section>
</template>

<script>
import BSN from "bootstrap.native/dist/bootstrap-native-v4";
import mdfile from "@/docs/components/comments.md";
export default {
  name: "comments",
  beforeCreate: function() {
    this.$emit("update-title", this.$root.yamlData.components.comments.name);
    this.$emit(
      "update-tagline",
      this.$root.yamlData.components.comments.description
    );
  },
  mounted: function() {
    const dropdowns = document.querySelectorAll('[data-toggle="dropdown"]');
    dropdowns.forEach(dropdown => {
      new BSN.Dropdown(dropdown);
    });
    const icons = document.querySelectorAll('[data-toggle="tooltip"]');
    icons.forEach(icon => {
      new BSN.Tooltip(icon);
    });
  },
  data() {
    return {
      mdfile
    };
  }
};
</script>
